module.exports = "<p>\n  Please wait ...\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/free-trial/free-trial.component.html
// module id = ./src/app/free-trial/free-trial.component.html
// module chunks = main